import { Component, OnInit } from '@angular/core';
import { parse } from 'querystring';
import { CommonService } from 'src/app/service/common.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {

  project;
  room;
  month_select;
  firstDay;
  lastDay;
  lastDayOfM;
  year;
  constructor(public cm:CommonService) { }

  ngOnInit() {
    this.project = this.cm.getProject();
    this.room = this.cm.encryption_service.get_secure_item("report_room");

    
    // data data
    const date = new Date();
    this.month_select = date.getMonth() + 1;
    this.year = date.getFullYear();
    this.firstDay = new Date(this.year, this.month_select - 1, 1);
    this.lastDay = new Date(this.year, this.month_select, 0); 
    this.lastDayOfM =  new Date(this.year, this.month_select, 0); 
    this.getReport(this.year, this.month_select);
    // this.testGetData();
  }

  report = [];
  sum_money = 0;
  sum_power = 0;
  check_payment_this_month = false;
  getReport(year,month){
    this.sum_money = 0;
    this.sum_power = 0;
    this.report = [];
    const date = new Date();
    this.firstDay = new Date(year, month - 1, 1);
    this.lastDay = new Date(year, month, 1); 
    this.lastDayOfM =  new Date(this.year, this.month_select, 0); 
    this.cm.db.collection('projects').doc(this.project.uid).collection('rooms').doc(this.room.uid).collection('activity',ref=>ref.where('create_time','>',this.firstDay.getTime()).where('create_time','<',this.lastDay.getTime()).where('code','==',100)).get().toPromise().then((data)=>{
      for(var i = 0;i < data.docs.length;i++){
        if(data.docs[i].data().power_total > 0 && data.docs[i].data().money > 0){
          // check same start time
          
          if(!(i != 0 && data.docs[i].data().start_time == data.docs[i-1].data().start_time)){
            this.report.push(data.docs[i].data());
            if(data.docs[i].data().money){
              this.sum_money = this.sum_money + parseFloat(data.docs[i].data().money);
            }
            if(data.docs[i].data().power_total){
              this.sum_power = this.sum_power + parseFloat(data.docs[i].data().power_total);
            }
          } 
        }
      }
      this.cm.sortBy(this.report,'create_time')
    }).then(()=>{
      // check payment
      this.check_payment_this_month = false;
      this.cm.db.collection('projects').doc(this.project.uid).collection('rooms').doc(this.room.uid).collection('bill',ref=>ref.where('check_payment','==',this.firstDay.getTime())).get().toPromise().then((data)=>{
        if(data.docs.length){
          this.check_payment_this_month = true;
        }
      })
    });  
  }

  selectMonth(month){
    const date = new Date();
    this.getReport(this.year,month);
  }

  selectYear(year){
    const date = new Date();
    this.getReport(year,this.month_select);
  }

  showNumber(data){
    if(data){
      return parseFloat(data).toFixed(2);
    }
    return "";
  }

  showMonthName(month){
    const month_data = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    return month_data[month - 1];
  }

  printDiv() {
    document.title =  this.project.name +' ,'+ this.room.room_name+' floor '+ this.room.floor +  ' building ' + this.room.building_name
    window.print();
  }

  calMoney(cal){
    return (parseFloat(cal)).toFixed(2);
  }

  checkout(){

    let check_sum_money = this.sum_money.toFixed(2);
    let cuurent = prompt("Please enter money to confirm :");
    if(parseFloat(cuurent) == parseFloat(check_sum_money)){

      this.cm.db.collection('projects').doc(this.project.uid).collection('rooms').doc(this.room.uid).get().toPromise().then((data)=>{
        var total_room = data.data().total;
        let money_update = parseFloat(total_room) - parseFloat(cuurent);
        
        var uid = this.cm.db.createId();
        var bill = {
          uid:uid,
          timestamp:(Date.now()),
          check_payment:this.firstDay.getTime(),
          checkout:String(cuurent),
        }
        
        this.cm.db.collection('projects').doc(this.project.uid).collection('rooms').doc(this.room.uid).update({
          total: String(money_update.toFixed(2))
        }).then(()=>{
          this.cm.db.collection('projects').doc(this.project.uid).collection('rooms').doc(this.room.uid).collection("bill").doc(uid).set(bill).then(()=>{
            this.cm.toastr.success('CHECK OUT','SUCCESS');
            this.getReport(this.year, this.month_select);
          });
        })
        
      })



     
    } else {
      this.cm.toastr.warning('SOMETHING WENT WRONG','WARNING');
    }
  }

  checkpaid_style(){
    var t = 0;
    if(this.check_payment_this_month){
      t = 0;
    } else {
      t = 1;
    } 
    return ((t * 140) + 485) + "px";
  }

  check_over_page(num_page){
    if(num_page > 40){
      return num_page
    } else if(num_page <= 40) {
      return 40
    }
  }
  


}
